import React from "react";

export default class GameButtonWithIcon extends React.Component{

    render() {
        let colorActive = `linear-gradient(180deg, ${this.props.colorStart ?? "#56CCF2"} 0%,${this.props.colorEnd ?? "#2D9CDB"} 100%)`;
        let colorInactive = "#DADADA";
        let style = {
            width: this.props.width ?? 20,
            height: this.props.height ?? 20,
            borderRadius: "3px",
            background: !this.props.disabled  ? colorActive : colorInactive,
            textAlign: 'center'
        }
        let iconStyle = {
            margin: this.props.title || this.props.margin ? (this.props.margin ?? "") : "auto",
            width: this.props.iconWidth ?? "auto",
            height: "auto",
            display: "block"
        }
        let styleFlex = {
            display: "flex"
        }
        let fontSize = this.props.fontSize ?? 20;
        let textStyle = {
            margin: "auto",
            fontWeight: this.props.fontWeight ?? "bold",
            color: "black",
            fontSize: `${fontSize}px`,
            lineHeight: `${fontSize}px`,
            textAlign: "left",
            marginLeft: this.props.marginText ??`5px`,
            textTransform: "uppercase",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.5)"
        }
        return <button className={this.props.isHideEvents ? "" : "game-btn"} style={{...style, ...this.props.style}} onClick={this.props.onClick}
                       disabled={this.props.disabled} title={this.props.tooltip}>
            <div style={styleFlex}>
                <img src={this.props.icon} style={iconStyle} alt={"icon"} />
                <div style={textStyle}>{this.props.title}</div>
            </div>
        </button>
    }
}
